import { Program } from '@bybeam/platform-types';
import BulletList, { BulletListProps } from '@platform-ui-common/components/BulletList/index.js';
import Typography from '@platform-ui-common/components/Typography/index.js';
import useApplicationConfig from '@platform-ui/application/hooks/useApplicationConfig.js';
import { programHasPayments } from '@platform-ui/utilities/programs.js';
import { useMemo } from 'react';
import Panel from './Panel.js';

export default function FollowupSteps({ program }: { program: Program }) {
  const { overrides } = useApplicationConfig();
  const hasPayments = programHasPayments(program);

  const list: BulletListProps['list'] = useMemo(() => {
    if (overrides?.submission?.bullets?.length) {
      return overrides?.submission?.bullets.map((bullet) => ({
        ...bullet,
        title: <Typography variant="h3">{bullet.title}</Typography>,
      }));
    }
    const bullets: BulletListProps['list'] = [
      {
        key: 'review',
        title: <Typography variant="h3">Application review</Typography>,
        icon: 'description',
        description:
          'While we look at your application, we might send you an email to ask for more information or documents.',
      },
      {
        key: 'decision',
        title: <Typography variant="h3">Application decision</Typography>,
        icon: 'mail',
        description:
          'We will email you our decision and give you next steps if your application is approved.',
      },
    ];

    if (hasPayments) {
      bullets.push({
        key: 'payments',
        title: <Typography variant="h3">Receiving a payment</Typography>,
        icon: 'money',
        description:
          'We will email you payment details and next steps if your application is approved.',
      });
    }
    return bullets;
  }, [hasPayments, overrides?.submission]);

  return (
    <Panel title={overrides?.submission?.title || 'What happens next?'}>
      <BulletList list={list} />
    </Panel>
  );
}
